import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../../common/TableHead";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Switch,
  TableHead,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import { Dispatcher } from "./SiteAboutPageUtils/siteAboutInterfaces";
import FormGroup from "@mui/material/FormGroup";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { PhoneListTextField } from "../../../common/PhoneListTextField";
import { CameraHealthTabAuopatrolEditMode } from "./CameraHealthTabAutopatrolEditMode";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  cadenceLabelToMinutes,
  cadenceMinutesToLabel,
  cadenceOptions,
} from "./SiteAboutPageUtils/cameraHealthCadenceUtils";
import {
  formatReportCadenceForDisplay,
  reportCadenceLabelToValue,
  reportCadenceOptions,
} from "./SiteAboutPageUtils/cameraHealthReportCadenceUtils";

const capitalizeWords = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

const lowerCaseWords = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toLowerCase());
};

export const CameraHealthTabEditMode = ({
  healthCheckData,
  setCameraHealthPatchObject,
  setCameraHealthChangesMade,
  siteInfo,
  setAddCameraHealthDialogOpen,
  setTurnOffHealthDialogOpen,
}: {
  healthCheckData: any;
  setCameraHealthPatchObject: any;
  setCameraHealthChangesMade: Dispatcher<boolean>;
  siteInfo: any;
  setAddCameraHealthDialogOpen: Dispatcher<boolean>;
  setTurnOffHealthDialogOpen: Dispatcher<boolean>;
}) => {
  const titlesArray = [
    "Camera Health Monitoring On",
    "Reports enabled",
    "Report Cadence",
    "Sensitivity",
    "Cadence",
  ];

  const titlesArray2 = [
    "All Metric Notifications",
    "All Metric Emails",
    "Report emails",
    "Cell Numbers",
    "",
  ];

  const sensitivityOptions = ["low", "medium", "high"];

  const {
    healthCheckMetricsData,
    setHealthCheckMetricsUpdated,
    setHealthCheckMetricsData,
    healthCheckMetricsUpdated,
  } = useSiteAboutStore();

  const [allMetricsChecked, setAllMetricsChecked] = React.useState(
    healthCheckMetricsData.scene_change_check.enabled &&
      healthCheckMetricsData.motion_status_check.enabled &&
      healthCheckMetricsData.recording_check.enabled &&
      healthCheckMetricsData.stream_quality_check.enabled &&
      healthCheckMetricsData.image_quality_check.enabled
  );

  const [currentCheckboxValues, setCurrentCheckboxValues] = React.useState({
    scene_change_check: healthCheckMetricsData.scene_change_check.enabled,
    motion_status_check: healthCheckMetricsData.motion_status_check.enabled,
    recording_check: healthCheckMetricsData.recording_check.enabled,
    stream_quality_check: healthCheckMetricsData.stream_quality_check.enabled,
    image_quality_check: healthCheckMetricsData.image_quality_check.enabled,
  });

  const [currentEmailsValues, setCurrentEmailsValues] = React.useState({
    connectivity_check:
      healthCheckMetricsData.connectivity_check.alert_emails || "",
    scene_change_check:
      healthCheckMetricsData.scene_change_check.alert_emails || "",
    motion_status_check:
      healthCheckMetricsData.motion_status_check.alert_emails || "",
    recording_check: healthCheckMetricsData.recording_check.alert_emails || "",
    stream_quality_check:
      healthCheckMetricsData.stream_quality_check.alert_emails || "",
    image_quality_check:
      healthCheckMetricsData.image_quality_check.alert_emails || "",
  });

  React.useEffect(() => {
    if (
      currentCheckboxValues.scene_change_check &&
      currentCheckboxValues.motion_status_check &&
      currentCheckboxValues.recording_check &&
      currentCheckboxValues.stream_quality_check &&
      currentCheckboxValues.image_quality_check
    ) {
      setAllMetricsChecked(true);
    } else {
      setAllMetricsChecked(false);
    }
  }, [currentCheckboxValues]);

  React.useEffect(() => {
    localStorage.setItem(
      "backupHealthCheckMetricsData",
      JSON.stringify(healthCheckMetricsData)
    );
  }, []);

  if (siteInfo.integration_type_name === "autopatrol") {
    return (
      <CameraHealthTabAuopatrolEditMode
        healthCheckData={healthCheckData}
        setCameraHealthPatchObject={setCameraHealthPatchObject}
        setCameraHealthChangesMade={setCameraHealthChangesMade}
        setAddCameraHealthDialogOpen={setAddCameraHealthDialogOpen}
        setTurnOffHealthDialogOpen={setTurnOffHealthDialogOpen}
      />
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{
          postion: "absolute",
          width: "screen",
          fontFamily: "Mulish",
        }}
      >
        {healthCheckData.deployment === 0 ? (
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                Camera Health Monitoring On
              </TableCell>
            </TableRow>
            <TableBody>
              <TableRow>
                <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                  <Switch
                    checked={healthCheckData.deployment === 3}
                    disabled={false}
                    color="warning"
                    onChange={() => {
                      setAddCameraHealthDialogOpen(true);
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </TableHead>
        ) : (
          <>
            <>
              <TableHeadComponent titlesArray={titlesArray} />
              <TableBody>
                <TableRow>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <Switch
                      checked={healthCheckData.deployment === 3}
                      disabled={false}
                      color="warning"
                      onChange={() => {
                        setTurnOffHealthDialogOpen(true);
                      }}
                    />
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {healthCheckData.report_emails_enabled ? (
                      <Switch
                        defaultChecked
                        disabled={false}
                        color="warning"
                        onChange={(event: any, value: any) => {
                          setCameraHealthPatchObject((previousState: any) => {
                            return {
                              ...previousState,
                              report_emails_enabled: value,
                            };
                          });
                          setCameraHealthChangesMade(true);
                        }}
                      />
                    ) : (
                      <Switch
                        disabled={false}
                        color="warning"
                        onChange={(event: any, value: any) => {
                          setCameraHealthPatchObject((previousState: any) => {
                            return {
                              ...previousState,
                              report_emails_enabled: value,
                            };
                          });
                          setCameraHealthChangesMade(true);
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <Autocomplete
                      disablePortal
                      disableClearable
                      options={reportCadenceOptions.map((option: string) => {
                        return formatReportCadenceForDisplay(option);
                      })}
                      defaultValue={formatReportCadenceForDisplay(
                        healthCheckData.report_cadence || "daily"
                      )}
                      onChange={(event: any, newInputValue: any) => {
                        if (newInputValue == null) {
                          return;
                        }
                        setCameraHealthPatchObject((previousState: any) => {
                          return {
                            ...previousState,
                            report_cadence:
                              reportCadenceLabelToValue(newInputValue),
                          };
                        });
                        setCameraHealthChangesMade(true);
                      }}
                      sx={{ width: 150 }}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Report Cadence"
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <Autocomplete
                      disablePortal
                      disableClearable
                      options={sensitivityOptions.map((option: string) => {
                        return capitalizeWords(option);
                      })}
                      defaultValue={capitalizeWords(
                        healthCheckData.sensitivity_level
                      )}
                      onChange={(event: any, newInputValue: any) => {
                        if (newInputValue == null) {
                          return;
                        }
                        setCameraHealthPatchObject((previousState: any) => {
                          return {
                            ...previousState,
                            sensitivity_level: lowerCaseWords(newInputValue),
                          };
                        });
                        setCameraHealthChangesMade(true);
                      }}
                      sx={{ width: 150 }}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Sensitivity"
                        />
                      )}
                    />
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <Autocomplete
                      disablePortal
                      disableClearable
                      options={cadenceOptions}
                      defaultValue={cadenceMinutesToLabel(
                        healthCheckData.cadence
                      )}
                      onChange={(event: any, newInputValue: any) => {
                        if (newInputValue == null) {
                          return;
                        }
                        setCameraHealthPatchObject((previousState: any) => {
                          return {
                            ...previousState,
                            cadence: cadenceLabelToMinutes(newInputValue),
                          };
                        });
                        setCameraHealthChangesMade(true);
                      }}
                      sx={{ width: 150 }}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Cadence"
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </>
            <>
              <TableHeadComponent titlesArray={titlesArray2} />
              <TableBody>
                <TableRow>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    {healthCheckData.alert_emails_enabled ? (
                      <Switch
                        defaultChecked
                        disabled={false}
                        color="warning"
                        onChange={(event: any, value: any) => {
                          setCameraHealthPatchObject((previousState: any) => {
                            return {
                              ...previousState,
                              alert_emails_enabled: value,
                            };
                          });
                          setCameraHealthChangesMade(true);
                        }}
                      />
                    ) : (
                      <Switch
                        disabled={false}
                        color="warning"
                        onChange={(event: any, value: any) => {
                          setCameraHealthPatchObject((previousState: any) => {
                            return {
                              ...previousState,
                              alert_emails_enabled: value,
                            };
                          });
                          setCameraHealthChangesMade(true);
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <TextField
                      defaultValue={healthCheckData.alert_emails}
                      variant="standard"
                      sx={{ width: 300 }}
                      type="string"
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setCameraHealthPatchObject((previousState: any) => {
                          return {
                            ...previousState,
                            alert_emails: event.target.value,
                          };
                        });
                        setCameraHealthChangesMade(true);
                      }}
                    />
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <TextField
                      defaultValue={healthCheckData.report_emails}
                      variant="standard"
                      type="string"
                      sx={{ width: 300 }}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setCameraHealthPatchObject((previousState: any) => {
                          return {
                            ...previousState,
                            report_emails: event.target.value,
                          };
                        });
                        setCameraHealthChangesMade(true);
                      }}
                    />
                  </TableCell>
                  <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                    <PhoneListTextField
                      fieldKey="camera-health-cell-numbers"
                      storedValue={healthCheckData.cell_numbers}
                      onValueChange={(value: string) => {
                        setCameraHealthPatchObject((previousState: any) => {
                          return {
                            ...previousState,
                            cell_numbers: value,
                          };
                        });
                        setCameraHealthChangesMade(true);
                      }}
                    />
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </>
          </>
        )}
      </Table>
      {healthCheckData.deployment !== 0 && (
        <Table
          sx={{
            postion: "absolute",
            width: "screen",
            fontFamily: "Mulish",
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  fontFamily: "Mulish",
                  fontWeight: "Bold",
                }}
              >
                Health Metrics &nbsp; &nbsp;
                <Tooltip
                  title="Select metrics in addition to connectivity to monitor. Use fields below to send instant alerts for specific metrics to different recipients."
                  placement="top"
                  sx={{ fontSize: "15px", fontFamily: "mulish" }}
                >
                  <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                </Tooltip>
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <FormGroup>
                  <div className="flex">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={allMetricsChecked}
                          onChange={(event: any) => {
                            setHealthCheckMetricsUpdated({
                              connectivity_check: true,
                              scene_change_check: true,
                              motion_status_check: true,
                              recording_check: true,
                              stream_quality_check: true,
                              image_quality_check: true,
                            });
                            setCurrentCheckboxValues((prevState: any) => {
                              return {
                                ...prevState,
                                scene_change_check: event.target.checked,
                                motion_status_check: event.target.checked,
                                recording_check: event.target.checked,
                                stream_quality_check: event.target.checked,
                                image_quality_check: event.target.checked,
                              };
                            });
                            setHealthCheckMetricsData({
                              ...healthCheckMetricsData,
                              scene_change_check: {
                                ...healthCheckMetricsData.scene_change_check,
                                enabled: event.target.checked,
                              },
                              motion_status_check: {
                                ...healthCheckMetricsData.motion_status_check,
                                enabled: event.target.checked,
                              },
                              recording_check: {
                                ...healthCheckMetricsData.recording_check,
                                enabled: event.target.checked,
                              },
                              stream_quality_check: {
                                ...healthCheckMetricsData.stream_quality_check,
                                enabled: event.target.checked,
                              },
                              image_quality_check: {
                                ...healthCheckMetricsData.image_quality_check,
                                enabled: event.target.checked,
                              },
                            });
                          }}
                          name="all_metrics"
                        />
                      }
                      label="All Metrics"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ marginLeft: "20px" }}
                          checked={currentCheckboxValues.scene_change_check}
                          onChange={(event: any) => {
                            const isChecked = event.target.checked;
                            setCurrentCheckboxValues((prevState: any) => ({
                              ...prevState,
                              scene_change_check: isChecked,
                            }));
                            setHealthCheckMetricsData({
                              ...healthCheckMetricsData,
                              scene_change_check: {
                                ...healthCheckMetricsData.scene_change_check,
                                enabled: isChecked,
                              },
                            });
                            setHealthCheckMetricsUpdated({
                              ...healthCheckMetricsUpdated,
                              scene_change_check: true,
                            });
                          }}
                          name="scene_change_check"
                        />
                      }
                      label="Scene Change"
                    />
                    <FormControlLabel
                      sx={{ marginLeft: "20px" }}
                      control={
                        <Checkbox
                          checked={currentCheckboxValues.motion_status_check}
                          onChange={(event: any) => {
                            const isChecked = event.target.checked;
                            setCurrentCheckboxValues((prevState: any) => ({
                              ...prevState,
                              motion_status_check: isChecked,
                            }));
                            setHealthCheckMetricsData({
                              ...healthCheckMetricsData,
                              motion_status_check: {
                                ...healthCheckMetricsData.motion_status_check,
                                enabled: isChecked,
                              },
                            });
                            setHealthCheckMetricsUpdated({
                              ...healthCheckMetricsUpdated,
                              motion_status_check: true,
                            });
                          }}
                          name="motion_status_check"
                        />
                      }
                      label="Motion Status"
                    />
                    <FormControlLabel
                      sx={{ marginLeft: "20px" }}
                      control={
                        <Checkbox
                          checked={currentCheckboxValues.recording_check}
                          onChange={(event: any) => {
                            const isChecked = event.target.checked;
                            setCurrentCheckboxValues((prevState: any) => ({
                              ...prevState,
                              recording_check: isChecked,
                            }));
                            setHealthCheckMetricsData({
                              ...healthCheckMetricsData,
                              recording_check: {
                                ...healthCheckMetricsData.recording_check,
                                enabled: isChecked,
                              },
                            });
                            setHealthCheckMetricsUpdated({
                              ...healthCheckMetricsUpdated,
                              recording_check: true,
                            });
                          }}
                          name="recording_check"
                        />
                      }
                      label="Recording Status"
                    />
                    <FormControlLabel
                      sx={{ marginLeft: "20px" }}
                      control={
                        <Checkbox
                          checked={currentCheckboxValues.stream_quality_check}
                          onChange={(event: any) => {
                            const isChecked = event.target.checked;
                            setCurrentCheckboxValues((prevState: any) => ({
                              ...prevState,
                              stream_quality_check: isChecked,
                            }));
                            setHealthCheckMetricsData({
                              ...healthCheckMetricsData,
                              stream_quality_check: {
                                ...healthCheckMetricsData.stream_quality_check,
                                enabled: isChecked,
                              },
                            });
                            setHealthCheckMetricsUpdated({
                              ...healthCheckMetricsUpdated,
                              stream_quality_check: true,
                            });
                          }}
                          name="stream_quality_check"
                        />
                      }
                      label="Stream Quality"
                    />
                    <FormControlLabel
                      sx={{ marginLeft: "20px" }}
                      control={
                        <Checkbox
                          checked={currentCheckboxValues.image_quality_check}
                          onChange={(event: any) => {
                            const isChecked = event.target.checked;
                            setCurrentCheckboxValues((prevState: any) => ({
                              ...prevState,
                              image_quality_check: isChecked,
                            }));
                            setHealthCheckMetricsData({
                              ...healthCheckMetricsData,
                              image_quality_check: {
                                ...healthCheckMetricsData.image_quality_check,
                                enabled: isChecked,
                              },
                            });
                            setHealthCheckMetricsUpdated({
                              ...healthCheckMetricsUpdated,
                              image_quality_check: true,
                            });
                          }}
                          name="image_quality_check"
                        />
                      }
                      label="Image Quality"
                    />
                  </div>
                </FormGroup>
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
      {healthCheckData.deployment !== 0 && (
        <Table
          sx={{
            postion: "absolute",
            width: "screen",
            fontFamily: "Mulish",
          }}
        >
          <TableHeadComponent
            titlesArray={[
              "Scene Change Emails",
              "Motion Status Emails",
              "Recording Status Emails",
              "Stream Quality Emails",
            ]}
          />
          <TableBody>
            <TableRow>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                <TextField
                  value={currentEmailsValues.scene_change_check}
                  variant="standard"
                  sx={{ width: 300 }}
                  type="string"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = event.target.value;
                    setCurrentEmailsValues((prevState) => ({
                      ...prevState,
                      scene_change_check: newValue,
                    }));
                    setHealthCheckMetricsData({
                      ...healthCheckMetricsData,
                      scene_change_check: {
                        ...healthCheckMetricsData.scene_change_check,
                        alert_emails: newValue,
                      },
                    });
                    setHealthCheckMetricsUpdated({
                      ...healthCheckMetricsUpdated,
                      scene_change_check: true,
                    });
                  }}
                />
              </TableCell>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                <TextField
                  value={currentEmailsValues.motion_status_check}
                  variant="standard"
                  sx={{ width: 300 }}
                  type="string"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = event.target.value;
                    setCurrentEmailsValues((prevState) => ({
                      ...prevState,
                      motion_status_check: newValue,
                    }));
                    setHealthCheckMetricsData({
                      ...healthCheckMetricsData,
                      motion_status_check: {
                        ...healthCheckMetricsData.motion_status_check,
                        alert_emails: newValue,
                      },
                    });
                    setHealthCheckMetricsUpdated({
                      ...healthCheckMetricsUpdated,
                      motion_status_check: true,
                    });
                  }}
                />
              </TableCell>

              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                <TextField
                  value={currentEmailsValues.recording_check}
                  variant="standard"
                  sx={{ width: 300 }}
                  type="string"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = event.target.value;
                    setCurrentEmailsValues((prevState) => ({
                      ...prevState,
                      recording_check: newValue,
                    }));
                    setHealthCheckMetricsData({
                      ...healthCheckMetricsData,
                      recording_check: {
                        ...healthCheckMetricsData.recording_check,
                        alert_emails: newValue,
                      },
                    });
                    setHealthCheckMetricsUpdated({
                      ...healthCheckMetricsUpdated,
                      recording_check: true,
                    });
                  }}
                />
              </TableCell>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                <TextField
                  value={currentEmailsValues.stream_quality_check}
                  variant="standard"
                  sx={{ width: 300 }}
                  type="string"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = event.target.value;
                    setCurrentEmailsValues((prevState) => ({
                      ...prevState,
                      stream_quality_check: newValue,
                    }));
                    setHealthCheckMetricsData({
                      ...healthCheckMetricsData,
                      stream_quality_check: {
                        ...healthCheckMetricsData.stream_quality_check,
                        alert_emails: newValue,
                      },
                    });
                    setHealthCheckMetricsUpdated({
                      ...healthCheckMetricsUpdated,
                      stream_quality_check: true,
                    });
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
      {healthCheckData.deployment !== 0 && (
        <Table
          sx={{
            postion: "absolute",
            width: "screen",
            fontFamily: "Mulish",
          }}
        >
          <TableHeadComponent
            titlesArray={["Image Quality Emails", "Connectivity Status Emails"]}
          />
          <TableBody>
            <TableRow>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                <TextField
                  value={currentEmailsValues.image_quality_check}
                  variant="standard"
                  sx={{ width: 300 }}
                  type="string"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = event.target.value;
                    setCurrentEmailsValues((prevState) => ({
                      ...prevState,
                      image_quality_check: newValue,
                    }));
                    setHealthCheckMetricsData({
                      ...healthCheckMetricsData,
                      image_quality_check: {
                        ...healthCheckMetricsData.image_quality_check,
                        alert_emails: newValue,
                      },
                    });
                    setHealthCheckMetricsUpdated({
                      ...healthCheckMetricsUpdated,
                      image_quality_check: true,
                    });
                  }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  value={currentEmailsValues.connectivity_check}
                  variant="standard"
                  sx={{ width: 300 }}
                  type="string"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newValue = event.target.value;
                    setCurrentEmailsValues((prevState) => ({
                      ...prevState,
                      connectivity_check: newValue,
                    }));
                    setHealthCheckMetricsData({
                      ...healthCheckMetricsData,
                      connectivity_check: {
                        ...healthCheckMetricsData.connectivity_check,
                        alert_emails: newValue,
                      },
                    });
                    setHealthCheckMetricsUpdated({
                      ...healthCheckMetricsUpdated,
                      connectivity_check: true,
                    });
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};
